import _BaseAPIService from "../_BaseAPIService";

const apiService = _BaseAPIService.instance;

const PackageServices = {
  get: async () => {
    const response = await apiService.get("/client-packages");

    console.log("resonponse", response);
    return response.data;
  },

  getById: async (id) => {
    const response = await apiService.get(`/client-packages/${id}`);
    return response.data;
  },

  getSlot: async ({ date, duration }) => {
    console.log('date to send', date);
    const response = await apiService.get("/time-slots", {
      params: { date, duration },
    });
    console.log("slotresponse", response);
  
    return response.data;
  },
};

export default PackageServices;
